export default function LocalIntro() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-6 md:mb-8">
            Votre réparateur de fenêtre à Haguenau
          </h2>
          <div className="space-y-5 text-plum-dark text-base md:text-lg leading-relaxed">
            <p>
              Haguenau compte parmi les plus belles maisons à colombages du nord alsacien. Entre le centre historique et les lotissements récents, chaque fenêtre a son histoire. Nos techniciens interviennent chez vous, pièce comprise, pour remettre en état mécanismes et quincailleries.
            </p>
            <p>
              Entre la forêt de Haguenau et les rues du centre historique, le parc immobilier est riche et varié. Les maisons à colombages côtoient les lotissements récents, et chaque fenêtre a ses particularités. Chez DF PRO, nous connaissons bien le nord du Bas-Rhin et intervenons chez vous pour réparer le mécanisme, sans changer la menuiserie entière.
            </p>
            <p>
              Notre atelier de Strasbourg est à une demi-heure d'Haguenau. Cette proximité nous permet de proposer des créneaux rapides, le déplacement est offert, le devis est gratuit et la pièce de remplacement est incluse dans l'intervention. Chaque réparation est garantie 10 ans.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}